'use client';

import { twMerge } from 'tailwind-merge';
import { ReactNode } from 'react';

export const HoverableIcon = ({
  icon,
  label,
  isActive,
  onMouseEnter,
  onMouseLeave,
  className,
}: {
  icon: ReactNode;
  label: string;
  isActive: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  className?: string;
}) => {
  return (
    <div
      className={twMerge('relative cursor-pointer ', className)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="transition-all">
        <div className="flex max-h-5 items-center gap-2 rounded-sm transition-all">
          <div className="h-5 w-5 text-grey-300 hover:text-white">{icon}</div>
          {isActive && <span className="font-sans text-sm whitespace-nowrap">{label}</span>}
        </div>
      </div>
    </div>
  );
};
